/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetRiskAnalysisStatusSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetRiskAnalysisStatusSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetRiskAnalysisStatusSecurity = {
  option1?: GetRiskAnalysisStatusSecurityOption1 | undefined;
  option2?: GetRiskAnalysisStatusSecurityOption2 | undefined;
};

export type GetRiskAnalysisStatusRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetRiskAnalysisStatusSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetRiskAnalysisStatusSecurityOption1$outboundSchema: z.ZodMiniType<
  GetRiskAnalysisStatusSecurityOption1$Outbound,
  GetRiskAnalysisStatusSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getRiskAnalysisStatusSecurityOption1ToJSON(
  getRiskAnalysisStatusSecurityOption1: GetRiskAnalysisStatusSecurityOption1,
): string {
  return JSON.stringify(
    GetRiskAnalysisStatusSecurityOption1$outboundSchema.parse(
      getRiskAnalysisStatusSecurityOption1,
    ),
  );
}

/** @internal */
export type GetRiskAnalysisStatusSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetRiskAnalysisStatusSecurityOption2$outboundSchema: z.ZodMiniType<
  GetRiskAnalysisStatusSecurityOption2$Outbound,
  GetRiskAnalysisStatusSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getRiskAnalysisStatusSecurityOption2ToJSON(
  getRiskAnalysisStatusSecurityOption2: GetRiskAnalysisStatusSecurityOption2,
): string {
  return JSON.stringify(
    GetRiskAnalysisStatusSecurityOption2$outboundSchema.parse(
      getRiskAnalysisStatusSecurityOption2,
    ),
  );
}

/** @internal */
export type GetRiskAnalysisStatusSecurity$Outbound = {
  Option1?: GetRiskAnalysisStatusSecurityOption1$Outbound | undefined;
  Option2?: GetRiskAnalysisStatusSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetRiskAnalysisStatusSecurity$outboundSchema: z.ZodMiniType<
  GetRiskAnalysisStatusSecurity$Outbound,
  GetRiskAnalysisStatusSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetRiskAnalysisStatusSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetRiskAnalysisStatusSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getRiskAnalysisStatusSecurityToJSON(
  getRiskAnalysisStatusSecurity: GetRiskAnalysisStatusSecurity,
): string {
  return JSON.stringify(
    GetRiskAnalysisStatusSecurity$outboundSchema.parse(
      getRiskAnalysisStatusSecurity,
    ),
  );
}

/** @internal */
export type GetRiskAnalysisStatusRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetRiskAnalysisStatusRequest$outboundSchema: z.ZodMiniType<
  GetRiskAnalysisStatusRequest$Outbound,
  GetRiskAnalysisStatusRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getRiskAnalysisStatusRequestToJSON(
  getRiskAnalysisStatusRequest: GetRiskAnalysisStatusRequest,
): string {
  return JSON.stringify(
    GetRiskAnalysisStatusRequest$outboundSchema.parse(
      getRiskAnalysisStatusRequest,
    ),
  );
}
